import { trigger, transition, style, animate, query, group } from '@angular/animations';

export default trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }),
      ],
      { optional: true },
    ),
    query(':enter', [style({ opacity: 0 })], { optional: true }),
    group([
      query(':leave', [animate('200ms ease-out', style({ opacity: 0 }))], { optional: true }),
      query(':enter', [animate('300ms ease-in', style({ opacity: 1 }))], { optional: true }),
    ]),
  ]),
]);
